import discardMarkAsReadOption from './actions/discardMarkAsReadOption';
import saveMarkAsReadOption from './actions/saveMarkAsReadOption';
import MarkAsReadFull from './components/MarkAsReadFull';
import isMarkAsReadOptionDirty from './utils/isMarkAsReadOptionDirty';
import * as React from 'react';
var MarkAsReadOption = {
    key: 'markAsRead',
    titleStringKey: 'optionTitle_markAsRead',
    searchTermsStringKey: 'optionTitle_markAsRead',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MarkAsReadFull, null); },
        isDirty: isMarkAsReadOptionDirty,
        onSave: saveMarkAsReadOption,
        onDiscard: discardMarkAsReadOption,
    },
};
export default MarkAsReadOption;
//# sourceMappingURL=MarkAsReadOption.js.map